<template>
  <section class="industries-section position-relative see__pad">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="industries-header text-center">
            <div class="industries-section-label">
              <h4>{{ content.sectionLabel }}</h4>
            </div>
            <div class="industries-main-title">
              <h2>{{ content.mainTitle }} <span>{{ content.mainTitleHighlight }}</span></h2>
            </div>
            <div class="industries-description">
              <p>{{ content.description }}</p>
            </div>
          </div>
        </div>
      </div>
      
      <div class="industries-grid">
        <div 
          v-for="(industry, index) in content.industries" 
          :key="index"
          class="industry-item wow fadeInUp"
          :data-wow-delay="`0.${index + 1}s`"
        >
          <div class="industry-icon">{{ industry.icon }}</div>
          <h3>{{ industry.name }}</h3>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "HomeItsAboutUsComp",
  props: {
    content: {
      type: Object,
      required: true,
      default: () => ({
        sectionLabel: "Industries We Serve",
        mainTitle: "Transforming Industries with",
        mainTitleHighlight: "Software Innovation",
        description: "We serve diverse industries with specialized software solutions tailored to their unique challenges and requirements.",
        industries: [
          {
            icon: "🏥",
            name: "Healthcare"
          },
          {
            icon: "💰",
            name: "Fintech"
          },
          {
            icon: "🎓",
            name: "Education"
          },
          {
            icon: "🛒",
            name: "E-commerce"
          },
          {
            icon: "🚚",
            name: "Logistics"
          },
          {
            icon: "🏭",
            name: "Manufacturing"
          },
          {
            icon: "🚗",
            name: "Automotive"
          },
          {
            icon: "🤖",
            name: "AI/ML"
          },
          {
            icon: "🏠",
            name: "Real Estate"
          },
          {
            icon: "📊",
            name: "Research Agencies"
          }
        ]
      })
    }
  }
}
</script>

<style scoped>
/* Industries Section Styles */
.industries-section {
  padding: 100px 0;
  background: #00061A;
  position: relative;
}

.industries-header {
  margin-bottom: 60px;
}

.industries-section-label h4 {
  font-size: 20px;
  font-weight: 400;
  letter-spacing: 13.2px;
  color: #F6EC4F;
  margin-bottom: 20px;
  font-family: 'Archivo', sans-serif;
  text-transform: uppercase;
}

.industries-main-title h2 {
  font-size: 48px;
  font-weight: 700;
  line-height: 58px;
  color: #ffffff;
  margin-bottom: 20px;
  font-family: 'Archivo', sans-serif;
}

.industries-main-title h2 span {
  color: #F6EC4F;
}

.industries-description p {
  font-size: 18px;
  line-height: 28px;
  color: #ffffff;
  max-width: 600px;
  margin: 0 auto;
  font-family: 'Open Sans', sans-serif;
}

.industries-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 30px;
  margin-top: 50px;
}

.industry-item {
  text-align: center;
  padding: 30px 20px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 15px;
  border: 1px solid rgba(246, 236, 79, 0.2);
  transition: all 0.3s ease;
  cursor: pointer;
}

.industry-item:hover {
  background: rgba(246, 236, 79, 0.1);
  border-color: #F6EC4F;
  transform: translateY(-5px);
}

.industry-icon {
  font-size: 48px;
  margin-bottom: 20px;
  display: block;
}

.industry-item h3 {
  font-size: 18px;
  font-weight: 600;
  color: #ffffff;
  margin: 0;
  font-family: 'Archivo', sans-serif;
}

/* Responsive Design */
@media only screen and (max-width: 991px) {
  .industries-section {
    padding: 80px 0;
  }
}

@media only screen and (max-width: 767px) {
  .industries-section {
    padding: 60px 0;
  }
  .industries-main-title h2 {
    font-size: 36px;
    line-height: 46px;
  }
  
  .industries-description p {
    font-size: 16px;
  }
  
  .industries-grid {
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
  }
  
  .industry-item {
    padding: 20px 15px;
  }
  
  .industry-icon {
    font-size: 36px;
    margin-bottom: 15px;
  }
  
  .industry-item h3 {
    font-size: 16px;
  }
}

@media only screen and (max-width: 399px) {
  .industries-section {
    padding: 40px 0;
  }
  
  /* Industries Section Responsive for Small Screens */
  .industries-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 15px;
  }
  
  .industry-item {
    padding: 15px 10px;
  }
  
  .industry-icon {
    font-size: 32px;
    margin-bottom: 10px;
  }
  
  .industry-item h3 {
    font-size: 14px;
  }
}
</style>
